"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _Alerts = require("customer-data-ui-utilities/alerts/Alerts");

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _enviro = _interopRequireDefault(require("enviro"));

function _default(error) {
  var BETPortalId = _enviro.default.isQa() ? 99535353 : 53;

  if (BETPortalId === _hubspot.default.get() && error.xhr && error.xhr.responseText) {
    var message = JSON.parse(error.xhr.responseText).message;

    _FloatingAlertStore.default.addAlert({
      message: message,
      type: 'warning'
    });

    return;
  }

  (0, _Alerts.addError)('ObjectsActions.alerts.alertUpdatePropertiesError');
}

module.exports = exports.default;